import { Fetcher, useActionData } from '@remix-run/react';
import { ActionToastResponse, ActionToastType, cn, textToRichText } from '@theprintbar/shared';
import { useEffect, useState } from 'react';
import { Modal } from '../Modal';
import { RichText } from '../RichText';

interface ActionToastProps {
	timeToClear?: number;
	fetcher?: Fetcher;
	localToast?: ActionToastResponse;
	clearLocalToast?: () => void;
}

export function ActionToast({ timeToClear = 3000, fetcher, localToast, clearLocalToast }: ActionToastProps) {
	const [toast, setToast] = useState<ActionToastResponse['actionToast']>();
	const data = useActionData<ActionToastResponse>();

	useEffect(() => {
		const { actionToast } = localToast || (fetcher ? (fetcher?.data as ActionToastResponse) || {} : data) || {};
		if (actionToast) {
			setToast(actionToast);
			if (!actionToast.requireClose) {
				setTimeout(() => {
					setToast(undefined);
					clearLocalToast?.();
				}, timeToClear);
			}
		}
	}, [data, fetcher, localToast]);

	return (
		<Modal
			open={!!toast}
			useLoading={false}
			onClose={() => setToast(undefined)}
			className={cn(
				toast?.type === ActionToastType.Success && 'bg-green-50 border-green',
				toast?.type === ActionToastType.Error && 'bg-red-50 border-red',
				toast?.type === ActionToastType.Warning && 'bg-yellow-50 border-yellow',
				toast?.type === ActionToastType.Info && 'bg-blue-50 border-blue',
			)}
		>
			{!!toast && (
				<>
					<h5 className="text-lg uppercase">{toast?.title}</h5>
					<RichText content={{ document: textToRichText(toast?.message) }} />
					{toast?.messages?.length && (
						<ul>
							{toast.messages.map((message, i) => (
								<li key={i}>{message}</li>
							))}
						</ul>
					)}
				</>
			)}
		</Modal>
	);
}
